<template>
  <div class="carousel_wrap">
    <!-- 用div替换el-carousel -->
    <div
      class="carousel_div"
      style="position: relative"
      :style="{ height: carouselHeight }"
    >
      <div
        v-for="(item, index) in imgList"
        :key="index"
        class="carousel_item_div"
        style="height: 100%; position: relative"
      >
        <!-- 用视频替换图片 -->
        <video
          v-if="item.type === 'video'"
          :src="item.src"
          class="img_item"
          autoplay
          loop
          muted
          playsinline
          webkit-playsinline
          x5-playsinline
          x5-video-orientation="portraint"
          x5-video-player-type="h5-page"
        ></video>
        <!-- 改为使用 gif 图片背景 -->
        <img
          :src="item.src"
          v-if="item.type !== 'video'"
          class="img_item"
          alt=""
        />
        <!-- <img src="../../assets/home/homeTextNew.png" class="homeTextNew" /> -->
        <div class="homeTextNew">
          <p style="white-space: nowrap; font-size: 8px">
            具身智能系统与群体智能集群异构协同行业解决方案专家
          </p>
          <p style="font-size: 7px" class="b-text">
            <span class="line"></span
            ><span style="white-space: nowrap"
              >「全空间无人体系智能装备行业领跑者」</span
            >
          </p>
        </div>
        <!-- <div class="ho_top"></div> -->
        <div class="tips_font_title_mobile">
          <!-- <img src="../../assets/home/homeText.png" class="icLo" /> -->

          <!-- <h1>无人集群智能化解决方案专家</h1>
          <p>无人化、集群化、智能化——无人化系统与装备行业领跑者</p> -->
          <div class="points_wrap">
            <div
              v-for="(point, index) in pointTexts"
              :key="index"
              class="point_item"
              :style="getRandomPosition(index)"
              @click="hoveredPointIndex = index"
            >
              <!-- @mouseup="hoveredPointIndex = null" -->
              <img src="../../assets/home/pointLi.png" alt="point" />
              <div class="point_text">
                <template v-if="hoveredPointIndex === index || isShow">
                  <div
                    class="point_desc"
                    @click.stop="hoveredPointIndex = null"
                  >
                    {{ point.desc }}
                  </div>
                  <div class="point_links">
                    <div
                      v-for="(link, lidx) in point.links"
                      :key="lidx"
                      class="point_link"
                      @click="handleLinkClick(link)"
                    >
                      {{ link.text }}
                    </div>
                  </div>
                </template>
                <template v-else>
                  {{ point.text }}
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [
        {
          // 使用本地 gif 背景替代视频
          src: "https://hr2.chnsoft.com.cn/home_top_mobile.gif",
          type: "image",
          line1: "产业大脑",
          line2: "赋能产业高质量发展",
        },
      ],
      pointTexts: [
        {
          text: "公司简介",
          desc: "公司简介",
          links: [{ text: "关于我们", path: "/about_us" }],
        },
        {
          text: "低空经济",
          path: "/security",
          id: 1,
          desc: "低空经济",
          links: [
            {
              text: "无人+公共安全",
              path: "/industry_application",
              query: { source: "industry_uav_safe", navUserCaseType: 1 },
            },
            {
              text: "无人+执法",
              path: "/industry_application",
              query: { source: "industry_safety_1", navUserCaseType: 1 },
            },
            {
              text: "无人+应急",
              path: "/industry_application",
              query: { source: "industry_safety_2", navUserCaseType: 1 },
            },
            {
              text: "无人+环保",
              path: "/industry_application",
              query: { source: "industry_other_4", navUserCaseType: 1 },
            },
            {
              text: "无人+森林",
              path: "/industry_application",
              query: { source: "industry_uav_forest", navUserCaseType: 1 },
            },
            {
              text: "无人+水利",
              path: "/industry_application",
              query: { source: "industry_uav_water", navUserCaseType: 1 },
            },
            {
              text: "无人+投送",
              path: "/industry_application",
              query: { source: "industry_uav_delivery", navUserCaseType: 1 },
            },
          ],
        },
        {
          text: "电网",
          id: 2,
          desc: "电网",
          links: [
            {
              text: "输电线路",
              path: "/industry_application",
              query: { source: "industry_power_1", navUserCaseType: 2 },
            },
            {
              text: "变电（换流）站",
              path: "/industry_application",
              query: { source: "industry_power_2", navUserCaseType: 2 },
            },
            {
              text: "配网",
              path: "/industry_application",
              query: { source: "industry_power_3", navUserCaseType: 2 },
            },
          ],
        },
        {
          text: "新能源",
          id: 3,
          desc: "新能源",
          links: [
            {
              text: "光伏发电",
              path: "/industry_application",
              query: { source: "industry_energy_1", navUserCaseType: 3 },
            },
            {
              text: "风力发电",
              path: "/industry_application",
              query: { source: "industry_energy_2", navUserCaseType: 3 },
            },
            {
              text: "抽水蓄能",
              path: "/industry_application",
              query: { source: "industry_energy_3", navUserCaseType: 3 },
            },
          ],
        },
        {
          text: "能源",
          id: 4,
          desc: "能源",
          links: [
            {
              text: "石油",
              path: "/industry_application",
              query: { source: "industry_energy_4", navUserCaseType: 4 },
            },
            {
              text: "天然气",
              path: "/industry_application",
              query: { source: "industry_energy_5", navUserCaseType: 4 },
            },
            {
              text: "管网",
              path: "/industry_application",
              query: { source: "industry_guan_wang", navUserCaseType: 4 },
            },
            {
              text: "矿业",
              path: "/industry_application",
              query: { source: "industry_other_3", navUserCaseType: 4 },
            },
          ],
        },
        {
          text: "轨道交通",
          id: 5,
          desc: "轨道交通",
          links: [
            {
              text: "公路",
              path: "/industry_application",
              query: { source: "industry_gong_lu", navUserCaseType: 5 },
            },
            {
              text: "铁路",
              path: "/industry_application",
              query: { source: "industry_tie_lu", navUserCaseType: 5 },
            },
            {
              text: "地铁",
              path: "/industry_application",
              query: { source: "industry_di_tie", navUserCaseType: 5 },
            },
          ],
        },
        {
          text: "其他",
          id: 6,
          desc: "其他",
          links: [
            {
              text: "边海防",
              path: "/industry_application",
              query: { source: "industry_other_2", navUserCaseType: 6 },
            },
            {
              text: "港口",
              path: "/industry_application",
              query: { source: "industry_other_5", navUserCaseType: 6 },
            },
            {
              text: "基础建设",
              path: "/industry_application",
              query: { source: "industry_other_6", navUserCaseType: 6 },
            },
            {
              text: "海洋",
              path: "/industry_application",
              query: { source: "industry_hai_yang", navUserCaseType: 6 },
            },
          ],
        },
      ],
      isShow: false,
      hoveredPointIndex: null,
    };
  },
  computed: {
    carouselHeight() {
      // 路由地址为 /industry_application 时高度为 1080PX，否则根据分辨率判断
      // if (this.$route.path === '/industry_application') {
      //   return '1080PX';
      // }
      const h = window.innerWidth || window.screen.width;
      if (h > 1000) {
        return "460PX";
      } else if (h > 800) {
        return "365PX";
      } else {
        return "200PX";
      }
    },
  },
  methods: {
    getRandomPosition(index) {
      // const top = Math.random() * 80 + 10; // 随机生成 10% 到 90% 的 top 值
      // const left = Math.random() * 80 + 10; // 随机生成 10% 到 90% 的 left 值
      let top = 0;
      let left = 0;
      switch (index) {
        case 0:
          top = 19;
          left = 53;
          break;
        case 1:
          top = 76;
          left = 60;
          break;
        case 2:
          top = 16;
          left = 72;
          break;
        case 4:
          top = 69;
          left = 8;
          break;
        case 3:
          top = 31;
          left = 28;
          break;
        case 5:
          top = 60;
          left = 36;
          break;
        case 6:
          top = 63;
          left = 78;
          break;
      }
      return {
        position: "absolute",
        top: `${top}%`,
        left: `${left}%`,
      };
    },
    // 新增点击处理方法
    handlePointClick(point) {
      if (point.text === "公司简介") {
        this.$router.push({ path: "/about_us" });
      } else {
        this.$router.push({
          path: "/all_user_cases",
          query: { source: "all_user_cases", navUserCaseType: point.id },
        });
      }
    },
    handleLinkClick(link) {
      if (link.path) {
        let text = link.text;
        if (text) {
          localStorage.setItem("selectedText", text);
          if (text == "海空协同无人船（艇）") {
            localStorage.setItem("TeDianBgProName", "水上智能航空站");
          } else if (text == "陆空协同无人消防车") {
            localStorage.setItem("TeDianBgProName", "陆空协同无人消防车");
          } else if (text == "算力服务器") {
            localStorage.setItem("TeDianBgProName", "ZF-C200 边缘计算终端");
          } else if (text == "机载板卡") {
            localStorage.setItem("TeDianBgProName", "ZF-A400 算力板卡");
          } else if (text == "系留供电装置") {
            localStorage.setItem("TeDianBgProName", "系留供电装置 ");
          } else if (text == "无人装备便携地面站") {
            localStorage.setItem("TeDianBgProName", "无人装备便携地面站");
          } else if (text == "机载任务系统") {
            localStorage.setItem(
              "TeDianBgProName",
              "AMS-400-V112 机载任务系统"
            );
          } else if (text == "无人装备驾控台") {
            localStorage.setItem("TeDianBgProName", "无人装备驾控台");
          } else if (text == "智能全域巡视系统") {
            localStorage.setItem("TeDianBgProName", "智能全域巡视系统");
          } else if (text == "全域电网巡检系统") {
            localStorage.setItem("TeDianBgProName", "全域电网巡检系统");
          } else {
            localStorage.setItem("TeDianBgProName", text);
          }
        }
        if (link.query) {
          this.$router.push({ path: link.path, query: link.query });
        } else {
          this.$router.push({ path: link.path });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel_wrap,
.carousel_div,
.carousel_item_div {
  position: relative;
  z-index: 0; /* 确保父层不创建高于上层文字的堆叠层 */
}

/* 视频/图片统一用 img_item 填充并置于底层 */
.img_item {
  position: absolute;
  inset: 0; /* top:0; right:0; bottom:0; left:0; */
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  pointer-events: none; /* 让上层交互正常 */
  -webkit-transform: translateZ(
    0
  ); /* 强制 GPU 合成，避免某些安卓/内核把 video 放最上层 */
  transform: translateZ(0);
  will-change: transform, opacity;
}

/* 前端文字/点位置于视频之上 */
.tips_font_title_mobile {
  z-index: 999;
  position: absolute;
  inset: 0;
  display: flex;

  .icLo {
    width: 50%;
    height: auto;
    margin: auto;
  }

  h1 {
    font-size: 16px; // 1rem
    margin: 3.2px 0; // 0.2rem
  }

  p {
    font-size: 9.6px; // 0.6rem
    margin-top: 3.2px; // 0.2rem
  }

  .points_wrap {
    width: 100%;
    position: absolute;
    top: 0px;
    height: 100%;

    .point_item {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 12px; // 0.7rem
        height: 12px; // 0.7rem
      }

      // .point_text {
      //   height: 12PX; // 0.7rem
      //   border-radius: 6PX; // 0.35rem
      //   font-size: 8PX; // 0.4rem
      //   padding: 0 6PX; // 0.3rem
      // }

      .point_text {
        // margin-left: 8PX;
        width: auto;
        border-radius: 10px;
        border: 1px solid #fff;
        background-color: #0f6bf6;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 9px;
        padding: 2px 5px;
        flex-direction: column;
        min-width: 35px;
        min-height: 16px;
        max-width: 368px;

        .point_desc {
          font-size: 9px;
          font-weight: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #ffffff;
          opacity: 0.8;
          padding-bottom: 5px;
          margin-bottom: 3px;
          border-bottom: rgba(255, 255, 255, 0.1) 1px solid;
        }

        .point_links {
          display: flex;
          flex-direction: row;
          gap: 8px;
          color: #fff;
          flex-wrap: wrap; // 新增：允许链接换行

          .point_link {
            font-size: 9px;
            color: #fff;
            text-decoration: none;
            border-bottom: 1px dashed transparent;
            transition: color 0.2s, border-bottom 0.2s;
            cursor: pointer;
            white-space: normal; // 新增：文本自动换行
          }

          .point_link:hover {
            color: #fff;
            font-weight: bold;
            border-bottom: 1px solid #fff;
          }
        }
      }
    }
  }
}

/* 兼容旧的 el-carousel 项目规则（如有） */
.el-carousel__item {
  img,
  video {
    display: block;
  }
}

::v-deep .el-carousel__button {
  display: none;
}

.homeTextNew {
  position: absolute;
  left: 7px;
  top: 8px;
  width: 198px !important;

  opacity: 1;
  font-family: PingFang TC;
  font-size: 7px;

  line-height: normal;
  letter-spacing: 0px;
  font-variation-settings: "opsz" auto;
  color: #1e242a;
  text-shadow: 1px -1px 0px rgba(161, 208, 255, 0.6);
  text-align: center;
  line-height: 2;
  .b-text {
    display: flex;
    justify-content: left;
    align-items: center;
    .line {
      display: inline-block;
      height: 2px;
      width: 30px;
      background: linear-gradient(
        90deg,
        rgba(30, 36, 42, 0) 0%,
        rgba(30, 36, 42, 0.12) 100%
      );
      margin-right: 10px;
      border-radius: 4px;
      vertical-align: middle;
    }
  }
}
</style>
